<template>
  <div class="xitong">
    <div class="table-cont">
      <div class="table-item">
        <ul>
          <li v-for="(item,index) in list" :key="index">{{item}}</li>
        </ul>
      </div>
      <div class="table-item table-items">
        <ul>
          <li>V {{item.version}}</li>
          <li>{{item.owner}}</li>
          <li>{{item.category}}</li>
        </ul>
      </div>
      <div class="table-item">
        <ul>
          <li v-for="(item,index) in lists" :key="index">{{item}}</li>
        </ul>
      </div>
      <div class="table-item table-items">
        <ul>
          <li>{{item.useTime}}</li>
          <li>{{item.phone}}</li>
          <li>{{item.termOfValidity}}</li>
        </ul>
      </div>
    </div>
    <div class="title">2016 - 2019 @简博士 团队倾力打造</div>
  </div>
</template>
<script >
import { getinformation } from "../servers/api"
import Vue from 'vue'
export default {
  data () {
    return {
      list: ['程序版本', '版权所有', '客户类别'],
      lists: ['上线日期', '客户服务电话', '服务有效期'],
      item: {}
    }
  },
  created () {
    this.getgetinformation()
  },
  methods: {
    getgetinformation () {
      getinformation({}).then(res => {
        if (res.data.code == 1) {
          this.item = res.data.data || {};
          if (this.item.useTime.length > 10) {
            this.item.useTime = this.item.useTime.slice(0, 10)
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.xitong {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow: hidden;
  overflow-y: visible;
  font-size: 13px;
  color: #7f7f7f;
  .table-cont {
    width: 90%;
    border: 1px solid #d7d7d7;
    height: 150px;
    margin: 50px auto;
  }
  .table-item {
    width: 25%;
    height: 100%;
    background: rgb(169, 229, 225);
    text-align: center;
    line-height: 50px;
    float: left;
  }
  .table-items {
    background: #fff;
    text-align: center;
  }
  .title {
    font-size: 12px;
    color: rgb(215, 215, 215);
    width: 100%;
    text-align: center;
    margin-top: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shezhi/xitong.vue